import { render, staticRenderFns } from "./EditLumberDialog.vue?vue&type=template&id=1c25afc8"
import script from "./EditLumberDialog.vue?vue&type=script&lang=js"
export * from "./EditLumberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports